import Button from '@alltrails/shared/denali/components/Button';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import * as styles from './GiftTray.module.scss';
import BottomTray from '../../shared/BottomTray';

type Props = {
  closeTray: () => void;
  navigateTo: (to: string) => void;
};

const GiftTray = ({ closeTray, navigateTo }: Props) => (
  <BottomTray closeTray={closeTray}>
    <div className={styles.container}>
      <div className={styles.trayContent}>
        <div className={styles.spacer} />
        <div className={styles.buttonContainer}>
          <div className={styles.headline}>
            <FormattedMessage defaultMessage="Choose a checkout method" />
          </div>
          <div className={styles.loginButton}>
            <Button
              text={<FormattedMessage defaultMessage="Log in" />}
              onClick={() => navigateTo('/gift/login')}
              testId="gift-tray-login"
              variant="primary"
              width="full"
            />
          </div>
          <Button
            text={<FormattedMessage defaultMessage="Checkout as guest" />}
            onClick={() => navigateTo('/gift/payment')}
            testId="gift-tray-checkout-as-guest"
            variant="default"
            width="full"
          />
        </div>
      </div>
    </div>
  </BottomTray>
);

export default GiftTray;
